import * as constantsModule from '../variables'
import palette from './palette'
import breakpoints from './breakpoints'
import typography from './typography'
import muiTypography from './typography.mui'
import muiOverrides from './overrides.mui'
import muiProps from './props.mui'

const constants = { ...constantsModule }

/**
 * An object comprised of one or more {@link ThemeOverride} objects that is
 * provided to `createTheme` to override default theme values.
 * @typedef {Object.<string, ThemeOverride>} ThemeOverrides
 * @global
 */

/**
 * An object that is used to override default theme values.
 * @typedef {Object} ThemeOverride
 * @global
 */

/**
 * Material UI Theme Overrides
 * @type {ThemeOverrides}
 */
export const overrides = {
  breakpoints,
  constants,
  palette,
  typography,
  muiTypography,
  overrides: muiOverrides,
  props: muiProps
}

export { breakpoints, constants, palette }

export default overrides
